import { Fragment } from 'react'

import NoveltyCard from '@/components/Cart/Molecules/NoveltyCard'
import { AccessoryType } from '@/types/accessory'

export default function PackableAccessoryList({
  packableAccessories,
  label = 'ノベルティ',
}: {
  packableAccessories: AccessoryType[]
  label?: string
}) {
  return (
    <>
      {packableAccessories.map((accessory) => {
        return (
          <Fragment key={accessory.accessoryId}>
            <NoveltyCard
              image={{
                src: accessory.creative.publishUrl,
                width: accessory.creative.width,
                height: accessory.creative.height,
              }}
              displayName={accessory.displayName}
              displayLoginAlert={true}
              label={
                accessory.type == 'birthdayPresent'
                  ? '誕生日プレゼント'
                  : accessory.type == 'pointExchange'
                    ? 'ポイント交換商品'
                    : label
              }
              capacity={accessory.capacity}
              key={accessory.accessoryId}
            />
          </Fragment>
        )
      })}
    </>
  )
}
